import { render } from "./MemberDeals.vue?vue&type=template&id=d42b3f8c&scoped=true"
import script from "./MemberDeals.vue?vue&type=script&lang=js"
export * from "./MemberDeals.vue?vue&type=script&lang=js"

import "./MemberDeals.vue?vue&type=style&index=0&id=d42b3f8c&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d42b3f8c"]])

export default __exports__